import { render, staticRenderFns } from "./ViewProfiles.vue?vue&type=template&id=2793168d&"
import script from "./ViewProfiles.vue?vue&type=script&lang=js&"
export * from "./ViewProfiles.vue?vue&type=script&lang=js&"
import style0 from "./ViewProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports